import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

function TournamentDelete() {
  const { t } = useLanguage();
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournamentId, setSelectedTournamentId] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const formatDateWithLeadingZeros = (date) => {
    if (!date) return t('tournamentDelete.noDate');
    if (typeof date === 'string' && date.match(/^\d{2}\.\d{2}\.\d{4}$/)) return date;
    const d = new Date(date);
    if (isNaN(d.getTime())) return t('tournamentDelete.invalidDate');
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const formatTournamentDisplay = (tournament) => {
    if (!tournament) return '';
    const dateStr = formatDateWithLeadingZeros(tournament.date);
    const creatorName = [tournament.created_by_first_name, tournament.created_by_last_name]
      .filter(Boolean)
      .join(' ') || t('tournamentDelete.unknown');
    let display = `${dateStr} - ${tournament.name} - ${creatorName}`;
    if (tournament.is_active === 1) display += ' ✓';
    return display;
  };

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const response = await axios.get('/api/tournaments');
        const sortedTournaments = [...response.data].sort((a, b) => {
          if (!a.date && !b.date) return 0;
          if (!a.date) return 1;
          if (!b.date) return -1;
          return new Date(b.date) - new Date(a.date);
        });
        setTournaments(sortedTournaments);
      } catch (err) {
        setError(t('tournamentDelete.loadError'));
      }
    };
    fetchTournaments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = async () => {
    if (!selectedTournamentId) {
      setError(t('tournamentDelete.selectError'));
      return;
    }
    setLoading(true);
    setMessage('');
    setError('');
    try {
      await axios.delete(`/api/tournaments/${selectedTournamentId}`);
      setMessage(t('tournamentDelete.success'));
      setTournaments(tournaments.filter(t => t.id !== parseInt(selectedTournamentId)));
      setSelectedTournamentId('');
    } catch (err) {
      setError(t('tournamentDelete.deleteError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: 600, margin: '0 auto' }}>
      <h2>{t('tournamentDelete.title')}</h2>

      <div className="form-group">
        <label>{t('tournamentDelete.select')}</label>
        <select
          value={selectedTournamentId}
          onChange={(e) => setSelectedTournamentId(e.target.value)}
          disabled={loading}
        >
          <option value="">{t('tournamentDelete.choose')}</option>
          {tournaments.map(tournament => (
            <option key={tournament.id} value={tournament.id}>
              {formatTournamentDisplay(tournament)}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={handleDelete}
        disabled={loading || !selectedTournamentId}
        style={{ background: '#dc2626' }}
      >
        {loading ? t('tournamentDelete.deleting') : t('tournamentDelete.delete')}
      </button>

      {message && <p style={{ color: '#22c55e', marginTop: 16 }}>{message}</p>}
      {error && <p style={{ color: '#f87171', marginTop: 16 }}>{error}</p>}
    </div>
  );
}

export default TournamentDelete;
